import React, { useState } from 'react';
import { ChevronLeft, Calendar, Users, Clock, Info, AlertTriangle, Clock as ClockIcon, Search, Filter, Download, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ArchivedCommittees() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('');
  const [filterReason, setFilterReason] = useState('');
  // Mock data for archived committees
  const archivedCommittees = [{
    id: 101,
    name: 'Quality Standards Team',
    type: 'Sub-Committee',
    parentCommittee: 'Quality Assurance Committee',
    archiveType: 'Expired',
    archiveDate: '2023-07-25',
    lastMeetingDate: '2023-07-20',
    memberCount: 5,
    reason: 'Term completed successfully',
    completionRate: 100,
    documents: 12
  }, {
    id: 8,
    name: 'Quality Assurance Committee',
    type: 'Standard',
    parentCommittee: null,
    archiveType: 'Expired',
    archiveDate: '2023-07-28',
    lastMeetingDate: '2023-07-20',
    memberCount: 9,
    reason: 'Term completed successfully',
    completionRate: 100,
    documents: 25
  }, {
    id: 9,
    name: 'Temporary Budget Review Committee',
    type: 'Standard',
    parentCommittee: null,
    archiveType: 'Expired',
    archiveDate: '2023-06-15',
    lastMeetingDate: '2023-06-10',
    memberCount: 7,
    reason: 'Temporary committee term ended',
    completionRate: 95,
    documents: 18
  }, {
    id: 10,
    name: 'Office Relocation Committee',
    type: 'Standard',
    parentCommittee: null,
    archiveType: 'Cancelled',
    archiveDate: '2023-05-20',
    lastMeetingDate: '2023-04-30',
    memberCount: 6,
    reason: 'Project cancelled due to budget constraints',
    completionRate: 45,
    documents: 8
  }, {
    id: 201,
    name: 'Digital Transformation Team',
    type: 'Sub-Committee',
    parentCommittee: 'IT Committee',
    archiveType: 'Cancelled',
    archiveDate: '2023-04-15',
    lastMeetingDate: '2023-03-28',
    memberCount: 4,
    reason: 'Restructured into new Technology Innovation Committee',
    completionRate: 60,
    documents: 15
  }, {
    id: 11,
    name: 'COVID-19 Response Committee',
    type: 'Standard',
    parentCommittee: null,
    archiveType: 'Expired',
    archiveDate: '2023-03-10',
    lastMeetingDate: '2023-02-28',
    memberCount: 8,
    reason: 'Emergency committee dissolved after crisis resolution',
    completionRate: 100,
    documents: 32
  }, {
    id: 12,
    name: 'Sustainability Initiative Committee',
    type: 'Standard',
    parentCommittee: null,
    archiveType: 'Cancelled',
    archiveDate: '2023-02-15',
    lastMeetingDate: '2023-01-20',
    memberCount: 5,
    reason: 'Merged with Environmental Compliance Committee',
    completionRate: 35,
    documents: 7
  }];
  // Filter committees based on search and filter criteria
  const filteredCommittees = archivedCommittees.filter(committee => {
    return (searchTerm === '' || committee.name.toLowerCase().includes(searchTerm.toLowerCase())) && (filterType === '' || committee.archiveType === filterType) && (filterReason === '' || committee.reason.toLowerCase().includes(filterReason.toLowerCase()));
  });
  // Get unique archive types for filter dropdown
  const uniqueArchiveTypes = [...new Set(archivedCommittees.map(c => c.archiveType))];
  return <div data-id="element-231">
      <div className="flex items-center mb-6" data-id="element-232">
        <Link to="/committees" className="flex items-center text-gray-600 hover:text-gray-900 mr-4" data-id="element-233">
          <ChevronLeft size={20} className="mr-1" data-id="element-234" />
          Back to Committees
        </Link>
        <h1 className="text-2xl font-bold" data-id="element-235">Archived Committees</h1>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-236">
        <div className="text-gray-600 mb-4" data-id="element-237">
          <p data-id="element-238">
            This page displays all committees that have been cancelled or have
            expired. These committees are no longer active in the system.
          </p>
        </div>
        {/* Search and Filters */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-239">
          <div data-id="element-240">
            <div className="relative" data-id="element-241">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-242" />
              <input type="text" placeholder="Search by committee name..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-243" />
            </div>
          </div>
          <div data-id="element-244">
            <div className="relative" data-id="element-245">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-246">
                Archive Type
              </label>
              <select className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={filterType} onChange={e => setFilterType(e.target.value)} data-id="element-247">
                <option value="" data-id="element-248">All Types</option>
                {uniqueArchiveTypes.map((type, index) => <option key={index} value={type} data-id="element-249">
                    {type}
                  </option>)}
              </select>
            </div>
          </div>
          <div data-id="element-250">
            <div className="relative" data-id="element-251">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-252">
                Reason Contains
              </label>
              <input type="text" placeholder="Filter by reason..." className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={filterReason} onChange={e => setFilterReason(e.target.value)} data-id="element-253" />
            </div>
          </div>
        </div>
        {/* Results Table */}
        <div className="overflow-x-auto" data-id="element-254">
          <table className="w-full" data-id="element-255">
            <thead data-id="element-256">
              <tr className="bg-gray-50" data-id="element-257">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-258">
                  Committee Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-259">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-260">
                  Archive Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-261">
                  Archive Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-262">
                  Last Meeting
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-263">
                  Members
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-264">
                  Reason
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-265">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-266">
              {filteredCommittees.map(committee => <tr key={committee.id} className="hover:bg-gray-50" data-id="element-267">
                  <td className="px-6 py-4" data-id="element-268">
                    <div className="font-medium text-gray-900" data-id="element-269">
                      {committee.name}
                    </div>
                    {committee.parentCommittee && <div className="text-sm text-gray-500" data-id="element-270">
                        Sub-committee of {committee.parentCommittee}
                      </div>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-271">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${committee.type === 'Standard' ? 'bg-green-100 text-green-800' : 'bg-purple-100 text-purple-800'}`} data-id="element-272">
                      {committee.type}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-273">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${committee.archiveType === 'Expired' ? 'bg-gray-100 text-gray-800' : 'bg-red-100 text-red-800'}`} data-id="element-274">
                      {committee.archiveType}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-275">
                    <div className="flex items-center" data-id="element-276">
                      <Calendar size={16} className="text-gray-500 mr-2" data-id="element-277" />
                      <span data-id="element-278">{committee.archiveDate}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-279">
                    <div className="flex items-center" data-id="element-280">
                      <Clock size={16} className="text-gray-500 mr-2" data-id="element-281" />
                      <span data-id="element-282">{committee.lastMeetingDate}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-283">
                    <div className="flex items-center" data-id="element-284">
                      <Users size={16} className="text-gray-500 mr-2" data-id="element-285" />
                      <span data-id="element-286">{committee.memberCount}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-287">
                    <div className="text-sm text-gray-900 max-w-xs" data-id="element-288">
                      {committee.reason}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-289">
                    <div className="flex space-x-3" data-id="element-290">
                      <button className="text-orange-500 hover:text-orange-700" title="View Archive Record" data-id="element-291">
                        <FileText size={18} data-id="element-292" />
                      </button>
                      <button className="text-green-500 hover:text-green-700" title="Download Archive Report" data-id="element-293">
                        <Download size={18} data-id="element-294" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {filteredCommittees.length === 0 && <div className="text-center py-8" data-id="element-295">
            <p className="text-gray-500" data-id="element-296">
              No archived committees match your search criteria.
            </p>
          </div>}
      </div>
      {/* Archive Statistics */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-297">
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-298">
          <h3 className="text-lg font-semibold mb-3" data-id="element-299">Archive Summary</h3>
          <div className="space-y-4" data-id="element-300">
            <div className="flex justify-between items-center" data-id="element-301">
              <span className="text-gray-600" data-id="element-302">Total Archived:</span>
              <span className="font-semibold" data-id="element-303">{archivedCommittees.length}</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-304">
              <span className="text-gray-600" data-id="element-305">Expired:</span>
              <span className="font-semibold" data-id="element-306">
                {archivedCommittees.filter(c => c.archiveType === 'Expired').length}
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-307">
              <span className="text-gray-600" data-id="element-308">Cancelled:</span>
              <span className="font-semibold" data-id="element-309">
                {archivedCommittees.filter(c => c.archiveType === 'Cancelled').length}
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-310">
          <h3 className="text-lg font-semibold mb-3" data-id="element-311">Completion Rates</h3>
          <div className="space-y-3" data-id="element-312">
            <div data-id="element-313">
              <div className="flex justify-between text-sm mb-1" data-id="element-314">
                <span data-id="element-315">Expired Committees</span>
                <span data-id="element-316">100%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-317">
                <div className="h-2.5 rounded-full bg-green-500" style={{
                width: '100%'
              }} data-id="element-318"></div>
              </div>
            </div>
            <div data-id="element-319">
              <div className="flex justify-between text-sm mb-1" data-id="element-320">
                <span data-id="element-321">Cancelled Committees</span>
                <span data-id="element-322">47%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-323">
                <div className="h-2.5 rounded-full bg-orange-500" style={{
                width: '47%'
              }} data-id="element-324"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-325">
          <h3 className="text-lg font-semibold mb-3" data-id="element-326">Archive Timeline</h3>
          <div className="space-y-3" data-id="element-327">
            <div className="flex items-start" data-id="element-328">
              <div className="min-w-[80px] text-sm text-gray-500" data-id="element-329">Q1 2023</div>
              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-330">
                <div className="h-2.5 rounded-full bg-blue-500" style={{
                width: '30%'
              }} data-id="element-331"></div>
              </div>
              <div className="min-w-[30px] text-sm text-gray-500 ml-2" data-id="element-332">2</div>
            </div>
            <div className="flex items-start" data-id="element-333">
              <div className="min-w-[80px] text-sm text-gray-500" data-id="element-334">Q2 2023</div>
              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-335">
                <div className="h-2.5 rounded-full bg-blue-500" style={{
                width: '45%'
              }} data-id="element-336"></div>
              </div>
              <div className="min-w-[30px] text-sm text-gray-500 ml-2" data-id="element-337">3</div>
            </div>
            <div className="flex items-start" data-id="element-338">
              <div className="min-w-[80px] text-sm text-gray-500" data-id="element-339">Q3 2023</div>
              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-340">
                <div className="h-2.5 rounded-full bg-blue-500" style={{
                width: '30%'
              }} data-id="element-341"></div>
              </div>
              <div className="min-w-[30px] text-sm text-gray-500 ml-2" data-id="element-342">2</div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}